import React from 'react';
import { MessageCircle, Send } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Reveal } from '../Reveal';
import { supportHelps } from '../../data/content';
import { siteConfig } from '../../data/siteConfig';
export function SupportSection() {
  return <section className="bg-white py-16 md:py-[84px]" data-id="element-209" data-mp="3kuptdpx53kep">
      <div className="mx-auto max-w-[1120px] px-5" data-id="element-210" data-mp="3kv91kewzmufj">
        <SectionHeading kicker="Soporte y ayuda" icon={MessageCircle} title={<>
              No te dejamos <em data-id="element-212" data-mp="hdqx8hgfc5jv">solo/a</em>
            </>} lead="Si tienes una duda antes o después de comprar, estamos para ayudarte." data-id="element-211" data-mp="cemo1qti27tj" />
        <div className="mt-11 grid gap-6 md:grid-cols-[1.1fr_.9fr]" data-id="element-213" data-mp="7fta5xaawesu">
          <Reveal className="rounded-[28px] bg-forest p-6 text-cream md:p-[34px]" data-id="element-214" data-mp="7i5v8jbcv5a4">
            <h3 className="text-[25px] font-bold text-white" data-id="element-215" data-mp="2n5w91t3sk691">Soporte por email</h3>
            <p className="mt-2.5 text-forest-soft" data-id="element-216" data-mp="2s73irxphvfic">
              Escríbenos por cualquier problema con tu compra, la descarga o los archivos.
              Respondemos personalmente, de lunes a viernes.
            </p>
            <a href={`mailto:${siteConfig.supportEmail}`} className="mt-[22px] inline-flex max-w-full items-center gap-2.5 break-all rounded-full bg-white px-[22px] py-3.5 font-display text-[15px] font-bold text-forest transition-colors duration-150 ease-out hover:bg-cream md:text-[17px]" data-id="element-217" data-mp="1m0tj8ds887sk">
              <Send className="h-[18px] w-[18px] shrink-0" aria-hidden="true" data-id="element-218" data-mp="24y2zxn663764" />
              {siteConfig.supportEmail}
            </a>
          </Reveal>
          <ul className="flex flex-col gap-3.5" data-id="element-219" data-mp="2ioq25pb4zf6y">
            {supportHelps.map(({
            icon: Icon,
            title,
            text
          }, i) => <li key={title} data-id="element-220" data-mp="2epqvo09rbade" data-mpi={i}>
                <Reveal delay={i * 0.05} className="flex items-start gap-3.5 rounded-[20px] border border-line bg-white px-[22px] py-5" data-id="element-221" data-mp="2smw0jwxqi372">
                  <span className="flex h-[42px] w-[42px] shrink-0 items-center justify-center rounded-xl bg-tangerine" data-id="element-222" data-mp="2npvuhm0vx0fy">
                    <Icon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-223" data-mp="1l8tnxyjku5o9" />
                  </span>
                  <div data-id="element-224" data-mp="1paf9s9e39ual">
                    <b className="block font-display text-base text-forest" data-id="element-225" data-mp="1ubuu1z8fzwrx">{title}</b>
                    <span className="text-[15px] text-muted" data-id="element-226" data-mp="1z2b6bg0j1ccp">{text}</span>
                  </div>
                </Reveal>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}